<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.features.crm.headerTitle')" />

    <div class="base-container-first crm__wrapper">
      <ul class="crm__cards three-cards">
        <li
          v-for="(card, cardIndex) in CARDS"
          :key="cardIndex"
        >
          <SharedPageCard
            isWhite
            :card
          />
        </li>
      </ul>

      <SharedPageBusiness :business-list="BUSINESSES" />

      <ul class="crm__cards">
        <li
          v-for="(advantage, advantageIndex) in ADVANTAGES"
          :key="advantageIndex"
        >
          <SharedPageCard
            isWhite
            :card="advantage"
          />
        </li>
      </ul>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.features.crm.managerDescription')"
    :title="t('pages.features.crm.questionsTitle')"
  />
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

const CARDS = computed(() => [
  {
    description: t("pages.features.crm.cards.inOnePlace.description"),
    image: "crm-card-1",
    title: t("pages.features.crm.cards.inOnePlace.title"),
  },
  {
    description: t("pages.features.crm.cards.employees.description"),
    image: "crm-card-2",
    title: t("pages.features.crm.cards.employees.title"),
  },
  {
    description: t("pages.features.crm.cards.clients.description"),
    image: "crm-card-3",
    title: t("pages.features.crm.cards.clients.title"),
  },
]);

const BUSINESSES = computed(() => [
  t("pages.features.crm.businesses.beautySalon"),
  t("pages.features.crm.businesses.clothingStore"),
  t("pages.features.crm.businesses.lawyer"),
  t("pages.features.crm.businesses.barbershop"),
  t("pages.features.crm.businesses.carWash"),
  t("pages.features.crm.businesses.fitness"),
  t("pages.features.crm.businesses.notary"),
  t("pages.features.crm.businesses.photoStudio"),
  t("pages.features.crm.businesses.billiardRoom"),
  t("pages.features.crm.businesses.yourBusiness"),
]);

const ADVANTAGES = computed(() => [
  {
    description: t("pages.features.crm.cards.appointmentJournal.description"),
    image: "crm-card-4",
    title: t("pages.features.crm.cards.appointmentJournal.title"),
  },
  {
    description: t("pages.features.crm.cards.reports.description"),
    image: "crm-card-5",
    title: t("pages.features.crm.cards.reports.title"),
  },
]);

useSeoMeta({
  title: t("pages.features.crm.seo.title"),
});
</script>

<style scoped>
.crm__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 80px;
  margin: 0 auto 80px;
  padding: 0 24px;
}

@media (--desktop) {
  .crm__wrapper {
    row-gap: 120px;
    margin-bottom: 120px;
  }
}

.crm__cards {
  display: grid;
  row-gap: 16px;
}

@media (--desktop) {
  .crm__cards {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }
}

@media (--desktop) {
  .crm__cards.three-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
